import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Per-route title, description, canonical and robots for the app. Personal
// pages (a user's results and progress) are kept out of search results.
const ROUTES = {
  '/': {
    title: 'Cadenza — See the melody of your English',
    description: 'Speak and watch the melody of your voice drawn live, then train your pronunciation with an AI speech coach.',
  },
  '/accent-test': {
    title: 'Accent Test — I bet I can guess your accent in 30 seconds | Cadenza',
    description: 'Talk for 30 seconds and our AI guesses your accent, shows the sounds that give it away, and tells you where to start.',
  },
  '/practice': {
    title: 'Pronunciation Practice — 100 exercises scored sound by sound | Cadenza',
    description: 'Read short lines and 30-second passages out loud and get every word and sound scored, with tips on how to say it.',
  },
  '/results': { title: 'Your results | Cadenza', noindex: true },
  '/dashboard': { title: 'Your progress | Cadenza', noindex: true },
};

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export function PageMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = ROUTES[pathname] || ROUTES['/'];
    document.title = meta.title;
    if (meta.description) setMeta('meta[name="description"]', { name: 'description', content: meta.description });
    setMeta('meta[name="robots"]', { name: 'robots', content: meta.noindex ? 'noindex, nofollow' : 'index, follow' });
    setMeta('link[rel="canonical"]', { rel: 'canonical', href: `https://app.cadenza.coach${pathname === '/' ? '/' : pathname}` });
  }, [pathname]);
  return null;
}
